import React from 'react';
import PropTypes from 'prop-types';
import Panel from '../../Panel';
import { connect } from 'dva';
import difference from 'lodash-es/difference';
import concat from 'lodash-es/concat';
import SelectablePill from '../../../Form/SelectablePill';
import styles from './SlopeFilter.module.scss';
import { MAP_LAYER_IDS, MAP_MODES } from '../../../../lib/constants';

export function SlopeFilter(props) {
  const changeValue = (value) => (e) => {
    const checked = e.target.checked;
    if (checked != true) {
      props.onChange(difference(props.slopeValues, [value]));
    } else {
      props.onChange(concat(props.slopeValues, value));
    }
  };

  return (
    <Panel title='Slope' divider={true}>
      <div className={styles.pillGroup}>
        <SelectablePill
          disabled={!props.toolEnabled || props.isOnlyFlat}
          id='slope-cat-1'
          label='0-5˚'
          onChange={changeValue(1)}
          selected={props.slopeValues.includes(1)}
        />
        <SelectablePill
          disabled={!props.toolEnabled || props.isOnlyFlat}
          id='slope-cat-2'
          label='5-15˚'
          onChange={changeValue(2)}
          selected={props.slopeValues.includes(2)}
        />
        <SelectablePill
          disabled={!props.toolEnabled || props.isOnlyFlat}
          id='slope-cat-3'
          label='15-25˚'
          onChange={changeValue(3)}
          selected={props.slopeValues.includes(3)}
        />
        <SelectablePill
          disabled={!props.toolEnabled || props.isOnlyFlat}
          id='slope-cat-4'
          label='25-35˚'
          onChange={changeValue(4)}
          selected={props.slopeValues.includes(4)}
        />
        <SelectablePill
          disabled={!props.toolEnabled || props.isOnlyFlat}
          id='slope-cat-5'
          label='35˚+'
          onChange={changeValue(5)}
          selected={props.slopeValues.includes(5)}
        />
      </div>
    </Panel>
  );
}

SlopeFilter.propTypes = {
  elevationLayer: PropTypes.object,
  is3d: PropTypes.bool,
  isOnlyFlat: PropTypes.bool,
  onChange: PropTypes.func,
  slopeValues: PropTypes.array,
  toolEnabled: PropTypes.bool,
};

export default connect((model) => {
  const { map, terrain: { preferences }} = model
  return {
    elevationLayer: map.mapRef.findLayerById(MAP_LAYER_IDS.terrainAnalysis),
    is3d: map.mapMode === MAP_MODES.ThreeD,
    toolEnabled: preferences.terrainAnalysis.enabled,
  };
})(SlopeFilter);
